import Sidebar from "../../components/sidebar";
import Formulario from "../../components/formulario";
import SaveInfoConsulta from "../../api/save-info-consulta";
import './style.css';
import Loading from "../../components/loading";
import {useEffect, useState} from "react";
import Botao from "../../components/botao";
import {useParams} from "react-router-dom";
import InformacoesConsultaDiploma from "../../components/informacoes-consulta-diploma";
import InformacoesConsultaHistoricoPos from "../../components/informacoes-consulta-historico-pos";
import Header from "../../components/header";

export default function DiplomaPos() {
    const [error, setError] = useState("");
    const [loading, setLoadingStatus] = useState(true);
    const [mostrarSobreAluno, setMostrarSobreAluno] = useState(true);

    let { token } = useParams()

    useEffect(() => {
        const exec = async () => {
            if (!token) {
                setError('Não possui informações referente ao aluno')
                setLoadingStatus(false)
                return
            }

            fetch(process.env.REACT_APP_URL_API + 'consultar/POS?cpf=""&data_nascimento=""&matricula=""&token=' + token).then((response) => {
                return response.json();
            }).then((res) => {
                localStorage.setItem('info_page', JSON.stringify(res.data[0]))
                setLoadingStatus(false)
            }).catch((exp) => {
                console.error('Erro:', exp);
            })
        }
        exec();

    }, [token]);

    if (error !== "") {
        console.log(error);
    }

    const handleClick = () => {
        mostrarSobreAluno === true ? setMostrarSobreAluno(false) : setMostrarSobreAluno(true)
    }

    return (<Sidebar>
        <>
            <Header />
            <div className="pagina-conteudo">
                <div className="pagina-tabela">
                    <Formulario saveConsulta={new SaveInfoConsulta()}/>
                    <div>
                        {loading ? (
                            Loading()
                        ) : (
                            <div>
                                    <div>
                                        <div className='input-titulo-data-row'>
                                            <Botao onClick={handleClick} style={"botaoTrocar"}>
                                                Alternar para informações sobre
                                                o {mostrarSobreAluno !== true ? 'Aluno' : 'Histórico'}
                                            </Botao>
                                            {JSON.parse(localStorage.getItem('info_page')).links.length > 0 ? (
                                                <div className="button-enviar">
                                                    <a className="ml-2" type='button'
                                                       href={JSON.parse(localStorage.getItem('info_page')).links[0].download}>
                                                        <img src={"/images/consulta.svg"} width={32} height={32.5}
                                                             alt="Clean"/>
                                                    </a>
                                                </div>
                                            ) : ''
                                            }
                                        </div>

                                        {JSON.parse(localStorage.getItem('info_page')) && error === '' ? (
                                            <>
                                                <InformacoesConsultaDiploma mostrar={mostrarSobreAluno}
                                                                            data={JSON.parse(localStorage.getItem('info_page'))}/>
                                                <InformacoesConsultaHistoricoPos mostrar={!mostrarSobreAluno}
                                                                              data={JSON.parse(localStorage.getItem('info_page'))}/>
                                            </>
                                        ) : ''}
                                    </div>

                                {/*{error === '' && (*/}
                                {/*    <div>*/}
                                {/*        <div className='input-titulo-data-row mt-2'>*/}
                                {/*            <Link className="link-validacao" target="_blank"*/}
                                {/*                  to={'https://diplomadigital.techcert.com.br/validar/' + localStorage.getItem('info_page_techcert')[0].codigo_validacao_diploma}>*/}
                                {/*                Informações sobre o Diploma*/}
                                {/*            </Link>*/}

                                {/*            <Link className="link-validacao" target="_blank"*/}
                                {/*                  to={'https://diplomadigital.techcert.com.br/validar/' + localStorage.getItem('info_page_techcert')[0].codigo_validacao_historico}>*/}
                                {/*                Informações sobre o Histórico*/}
                                {/*            </Link>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*)}*/}
                                {error !== '' && (
                                    <div
                                        className="mt-5 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
                                        role="alert">
                                        <strong className="font-bold">Erro! </strong>
                                        <span className="block sm:inline">{error}</span>
                                        <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
                                            <svg className="fill-current h-6 w-6 text-red-500" role="button"
                                                 xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 20 20"><title>Close</title><path
                                                d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
                                        </span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    </Sidebar>);
}
